<template>
  <div id="app">
    <vue-image :sources="[
      { srcset: '/tinaba-bkg-small.jpg', media: '(max-width: 640px)' },
      { srcset: '/tinaba-bkg-large.jpg', media: '(min-width: 641px)' }
    ]" src="tinaba-bkg-large.jpg" class="fit fit-cover z-0" />
    <div>
      <header class="flex md:justify-center header pt-36 pb-40 relative z-50">
        <div class="header__logo sm:position-static sm:mx-auto sm:max-w-150">
          <a href="https://www.tinaba.bancaprofilo.it/it/" target="_blank">
            <img alt="Tinaba logo" class="block" src="@/assets/logo.png">
          </a>
        </div>
        <LangDropdown />
      </header>
      <div class="text-center text-14 font-medium text-white z-10 max-w-620 relative mx-auto w-10/12 md:w-8/12 mb-40" v-html="$t('tinaba-intro')"/>
      <router-view/>
    </div>
    <transition name="fade">
      <div v-if="isLoading" class="fixed global-loader-wrapper inset-0">
        <div class="global-loader bg-white absolute h-75 w-75 rounded-20 z-50 shadow-lg">
          <span class="spinner"></span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import LangDropdown from '@/components/LangDropdown'
import VueImage from '@/components/Image'

export default {
  components: {
    LangDropdown,
    VueImage
  }, 
  computed: {
    ...mapState('linkToPay', [
      'payment',
      'isLoading'
    ])
  }  
}
</script>
<style lang="scss">
  .global-loader-wrapper {
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.3);
  }
</style>